import { useI18n } from '@i18n';
import { Button } from '@mui/material';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Link } from 'react-router-dom';
import { IMAGES } from '@/assets';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { faro } from '@/faro';
import { PATHS } from '@/routes';

/**
 * The most general, outmost error boundary.
 * Serves as a fallback instead of a blank page and for user retention.
 */
function GeneralErrorBoundary({ children }: PropsWithChildren<{}>) {
  const { t } = useI18n();

  return (
    <ErrorBoundary
      onError={(error, info) => {
        faro?.api?.pushError(error);
        console.error({ error, info });
      }}
      key="GENERAL"
      fallback={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2rem',
            height: '100vh',
          }}
        >
          <PTypography variant={'h3'}>{t('General_AnErrorHasOccurred')}</PTypography>
          <PTypography variant={'body1'}>{t('GeneralErrorBoundary_Description')}</PTypography>
          <img src={IMAGES.ErrorFallbackGeneral} alt="A robot with two eyes and wrenches as arms." />

          <div>
            <Button
              variant="contained"
              component={Link}
              to={PATHS.root()}
              reloadDocument
              style={{ marginRight: '2rem' }}
            >
              {t('Page404_GoToHome')}
            </Button>
            <Button href="mailto:support@predium.de">{t('General_ContactSupport')}</Button>
          </div>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}

export default GeneralErrorBoundary;
